import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators,FormBuilder } from '@angular/forms';
import { MatDialog, MatStepper } from '@angular/material';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SweetAlertService } from '../../utils/sweetAlert/sweet-alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FichaAdmisionFacadeService } from './ficha-admision-facade.service';
import { S3Service } from '../../modules/coordinador/services/s3.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-ficha-admision',
  templateUrl: './ficha-admision.component.html',
  styleUrls: ['./ficha-admision.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }],
  encapsulation: ViewEncapsulation.Emulated
  })


export class FichaAdmisionComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') private myStepper: MatStepper;
  // @ViewChild('stepper') stepper: MatStepper;
  @HostListener('window:beforeunload', ['$event'])
  clearLocalStorage(event: any): void {
    localStorage.removeItem('DatosGenerales');// Borra los datos del localStorage
    localStorage.removeItem('DatosAcademicos'); 
    localStorage.removeItem('DatosLaborales');
  }
  newData: string = '';
  fechaMaxima: string;
  miFormulario: FormGroup;
  contador: number = 0;
  contadorEducacion : number = 0;
  contadorOtros : number = 0;
  contadorTrab: number = 0;


  public datosPersonalesForm: FormGroup;
  public datosLaboralesForm: FormGroup;
  public editingIndex: number | null = null;
  public editLenguajeIndex: number | null = null;
  public editOtroEstudioIndex: number | null = null;
  public editExperienciaLaboralIndex: number | null = null;

  public datosAcademicosForm: FormGroup;
  public otrosEstudiosForm: FormGroup;
  @ViewChild('EducacionTemplate') educacionTemplate: TemplateRef<any>;
  @ViewChild('IdiomaTemplate') idiomaTemplate: TemplateRef<any>;
  @ViewChild('OtrosEstudiosTemplate') otrosEstudiosTemplate: TemplateRef<any>;
  @ViewChild('ExperienciaLaboralTemplate') experienciaLaboralTemplate: TemplateRef<any>;
  @ViewChild('documentoRequisitoTemplate') documentoRequisitoTemplate: TemplateRef<any>;
  
  
  public datosAcademicos: any[] = [];
  

  public lenguajeForm: FormGroup;
  public lenguaje: any[] = [];
  public diplomadoArray: any[] = [];

  public trabajaForm = new FormControl(true);
  public empleosArray: any[] = [];
  public referenciasArray = new FormArray([]);

  public datosCarrera: any = {};
  public datosPostulacion: FormGroup;
  centroVirtual: any = {};

  public idCentro: number;
  public idCarrera: number;
  public eleccion: number;
  isExperienciaPublicacionVisible = true; 
  isExperienciaInvestigacionDisabled = false;

  
  orientaciones: any[] = [];
  orientacionSeleccionada: number | null = null;

  // Requisitos de postulación (paso final, tras crear la solicitud)
  public solicitudEnviada = false;
  public idSolicitudCreada: number | null = null;
  public mostrarRequisitosPostulacion = false;
  public postulacionInfo: any = null;
  public requisitosPostulacion: any[] = [];
  public detallesPostulacion: any[] = [];
  public requisitosAgrupados: any[] = [];

  // Modal de subida/reemplazo de documento de un requisito de postulación
  public detalleSeleccionado: any = null;
  public archivoSeleccionadoRequisito: File | null = null;
  public previewUrlRequisito: string | null = null;
  public safePreviewUrlRequisito: SafeResourceUrl | null = null;
  public isImageRequisito = false;
  public isPdfRequisito = false;
  public cargandoPreviewRequisito = false;
  public guardandoDocumentoRequisito = false;

  public suscripciones: Subscription = new Subscription();

  constructor(public toast: ToastrServiceLocal, public modal: MatDialog, public fichaAdmisionFacade: FichaAdmisionFacadeService, public router: Router, private activatedRoute: ActivatedRoute, private _formBuilder: FormBuilder,
    private sweetAlertService: SweetAlertService, private sanitizer: DomSanitizer, private srvS3: S3Service) {
    //calcular fecha maxima y minima de campo fecha nacimineto
    this.fechaMaxima = this.calcularFechaMaxima();
    this.miFormulario = this._formBuilder.group({
      fechaNacimiento: ['', [Validators.required]],
    });
  
    this.fichaAdmisionFacade.mostrarDatosGenerales('');
    this.suscripciones.add(
      this.trabajaForm.valueChanges.subscribe((result) => {
        if (result === "False") {
          this.datosLaboralesForm.disable();
        } else {
          this.datosLaboralesForm.enable();
        }
      })
    );

// validar el matstep
    // this.datosPersonalesForm = this._formBuilder.group({
    //   celularContacto: ['', Validators.required],
    // });
    //  this.datosPostulacion = this._formBuilder.group({
    //   razonesPostulacion: ['', Validators.required],
    // });

    this.datosLaboralesForm = this._formBuilder.group({
      trabajaForm: [true],
    });
    this.datosPersonalesForm = this._formBuilder.group({
      // Configura los campos y validadores necesarios
    });
    this.datosLaboralesForm = this._formBuilder.group({});
  
    this.datosPostulacion = this._formBuilder.group({});
    
    
//-----------------------------------------
    this.datosCarrera = JSON.parse(localStorage.getItem("carreraSeleccionada")) || {};
if ( this.datosCarrera.idModalidad === 2){
  this.centroVirtual = 'UNAH VIRTUAL'
}
else{
  this.centroVirtual = this.datosCarrera.centro
}
    this.idCentro = Number(this.activatedRoute.snapshot.paramMap.get('idCentro'));
    this.idCarrera = Number(this.activatedRoute.snapshot.paramMap.get('idPosgrado'));
    this.eleccion = Number(this.activatedRoute.snapshot.paramMap.get('eleccion'));
    this.inicializarFormularios();

  }

  calcularFechaMaxima(): string {
    const fechaActual = new Date();
    fechaActual.setFullYear(fechaActual.getFullYear() - 14);
    return fechaActual.toISOString().split('T')[0];
  }

  ngOnInit(): void {
    this.suscripciones.add(
      this.fichaAdmisionFacade.VerOrientaciones(this.idCarrera,this.datosCarrera.idPromocion).subscribe(response => {
        const orientaciones = response?.data?.Table0 || [];
    
        // verifico si la respuesta es solo 0
        if (orientaciones.length === 1 && orientaciones[0].Respuesta === 0) {
          this.orientaciones = []; // sin orientaciones  
        } else {
          this.orientaciones = orientaciones; // lista de orientaciones
        }
        // console.log('a', this.orientaciones);
      })
    );
     this.inicializarFormularios();
    // Suscribirse al cambio de tipo de identificación
    this.datosPersonalesForm.get('idTipoIdentificacion')?.valueChanges.subscribe(value => {
    });
    
    // Reinico noIdentificacion cuando cambie el idTipoIdentificacion
this.datosPersonalesForm.get('idTipoIdentificacion')?.valueChanges.subscribe(() => {
  this.datosPersonalesForm.get('noIdentificacion')?.setValue(null, { emitEvent: false });
});

    this.datosPersonalesForm.get('noIdentificacion')?.valueChanges.subscribe(value => {
      const tipoIdent = Number(this.datosPersonalesForm.get('idTipoIdentificacion')?.value);
      if (!value) return;
  
      if (tipoIdent === 1) {
     
        const soloNumeros = value.replace(/[^0-9]/g, '');
        if (soloNumeros !== value) {
          this.datosPersonalesForm.get('noIdentificacion')?.setValue(soloNumeros, { emitEvent: false });
        }
      }
  
      if (tipoIdent === 2) {
         const soloLetrasNumeros = value.replace(/[^a-zA-Z0-9]/g, '');
        if (soloLetrasNumeros !== value) {
          this.datosPersonalesForm.get('noIdentificacion')?.setValue(soloLetrasNumeros, { emitEvent: false });
        }
      }
    });


    
    this.datosPersonalesForm.get('correoElectronico')?.valueChanges.subscribe(() => {
      this.datosPersonalesForm.updateValueAndValidity({ onlySelf: false, emitEvent: false });
    });
    
    this.datosPersonalesForm.get('confirmarCorreo')?.valueChanges.subscribe(() => {
      this.datosPersonalesForm.updateValueAndValidity({ onlySelf: false, emitEvent: false });
    });


  }

  ngOnDestroy(): void {
    this.suscripciones.unsubscribe();
    // Los MatDialog viven en el overlay global, no en el router-outlet:
    // si se navega fuera de esta página con el modal abierto, hay que
    // cerrarlo explícitamente o queda flotando sobre la siguiente pantalla.
    this.modal.closeAll();
  }


  inicializarFormularios() {
    
    
    let datosGenerales = JSON.parse(localStorage.getItem("DatosGenerales")) || {};

    this.datosPersonalesForm = new FormGroup({
      idDatosPersonales: new FormControl(datosGenerales.idDatosPersonales || 0),
      idFormaFinanciamiento: new FormControl(1),
      idMotivoPostulacion: new FormControl(1),
      idHorario: new FormControl(1),


      idCentro: new FormControl(this.idCentro, [Validators.required]), //Parametro a recibir
      idCarrera: new FormControl(this.idCarrera, [Validators.required]), //Parametro a recibir
      idTipoIdentificacion: new FormControl(datosGenerales.idTipoIdentificacion || '', [Validators.required]),
      noIdentificacion: new FormControl((datosGenerales.noIdentificacion || '').toString().trim(), [Validators.required]),
      noCuenta: new FormControl(datosGenerales.noCuenta || ''),
      CorreoInstitucional: new FormControl(datosGenerales.CorreoPregrado || ''),
      primerNombre: new FormControl(datosGenerales.primerNombre || '', [Validators.required]),
      segundoNombre: new FormControl(datosGenerales.segundoNombre || ''),
      primerApellido: new FormControl(datosGenerales.primerApellido || '', [Validators.required]),
      segundoApellido: new FormControl(datosGenerales.segundoApellido || ''),
      sexo: new FormControl(datosGenerales.sexo || '', [Validators.required]),
      // idPaisOrigen: new FormControl(''),
      idNacionalidad: new FormControl(datosGenerales.idNacionalidad || '', [Validators.required]),
      fechaNacimiento: new FormControl(datosGenerales.fechaNacimiento || '', [Validators.required]),
      idEstadoCivil: new FormControl(datosGenerales.idEstadoCivil || '', [Validators.required]),
      lugarNaciemiento: new FormControl(datosGenerales.lugarNaciemiento || '', [Validators.required]),
      direccionResidencia: new FormControl(datosGenerales.direccionResidencia || '', [Validators.required]),
      correoElectronico: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
      ]),
      confirmarCorreo: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
      ]),
    
      celularContacto: new FormControl(datosGenerales.celularContacto || '', [Validators.required]),
      telefonoCasaContacto: new FormControl(datosGenerales.telefonoCasaContacto || ''),
      telefonoCelular: new FormControl(datosGenerales.telefonoCelular || ''),
      telefonoOficinaContacto: new FormControl(datosGenerales.telefonoOficinaContacto || ''),
      telefonoAlternativo: new FormControl(datosGenerales.telefonoAlternativo || ''),
      idGrupoEtnico: new FormControl(datosGenerales.idGrupoEtnico || ''),
      idTipoDiscapacidad: new FormControl(datosGenerales.idTipoDiscapacidad || ''),

    }, { validators: this.validarCorreosIguales.bind(this) });

    
    let datosAcademicosLocal = JSON.parse(localStorage.getItem("DatosAcademicos")) || {};

    this.datosAcademicos = datosAcademicosLocal?.datosAcademicos || [];
    this.lenguaje = datosAcademicosLocal?.lenguaje || [];
    this.diplomadoArray = datosAcademicosLocal?.diplomadoArray || [];

    this.datosAcademicosForm = new FormGroup({
      idGradoAcademico: new FormControl('', [Validators.required]),
      nombreGradoAcademico: new FormControl(''),
      titulo: new FormControl('', [Validators.required]),
      institucion: new FormControl('', [Validators.required]),
      nombreInstitucion: new FormControl(''),
      anoGraducion: new FormControl(''),
      indiceGraduacion: new FormControl(''),
      idUniversidad: new FormControl(''),
      duracionEstudio: new FormControl('')
    });

    this.lenguajeForm = new FormGroup({
      idIdioma: new FormControl('', [Validators.required]),
      idioma: new FormControl(''),
      comprende: new FormControl('', [Validators.required]),
      nombreComprende: new FormControl(''),
      habla: new FormControl('', [Validators.required]),
      nombrehabla: new FormControl(''),
      lee: new FormControl('', [Validators.required]),
      nombreLee: new FormControl(''),
      escribe: new FormControl('', [Validators.required]),
      nombreEscribe: new FormControl(''),
    });

    this.datosPostulacion = new FormGroup({
      razonesPostulacion: new FormControl('', [Validators.required]),
      maneraFinanciacionPosgrado: new FormControl('', [Validators.required]),
      cuentaTiempoAtenderPosgrado: new FormControl('', [Validators.required]),
      experienciaPublicacion: new FormControl(''),
      //descripcionExperiencia: new FormControl(''),
      cuentaConPublicaciones: new FormControl(''),
      //descripcionPublicaciones: new FormControl('', [Validators.required]),
      experiencaInvestigacion: new FormControl(''),

      // referenciaPosgrado: new FormControl(''),
     // haCursadoClasesenLinea: new FormControl(''),
      //plataformas: new FormControl(''),
      //cursadoAsignaturaDocenteApoyaPlataformaVirtual: new FormControl(''),
      //haManejadoProgramaMicrosoftProject: new FormControl(''),
      experienciapreviaInvestigacion: new FormControl(''),
      //experiencia: new FormControl(''),

    });

    this.otrosEstudiosForm = new FormGroup({
      idTipoEstudio: new FormControl('', [Validators.required]),
      nombreTipoEstudio: new FormControl(''),
      titulo: new FormControl('', [Validators.required]),
      institucion: new FormControl('', [Validators.required]),
      anoObtencion: new FormControl('', [Validators.required]),
    })


    for (let i = 0; i < 2; i++) {

      let referencia = new FormGroup({
        nombre: new FormControl(''),
        numeroTelefono: new FormControl('')
      });

      this.referenciasArray.push(referencia);



    }

    this.datosLaboralesForm = new FormGroup({
      trabajaForm: new FormControl(''),
      idTipoInstitucion: new FormControl('', [Validators.required]),
      nombreTipoInstitucion: new FormControl(''),
      institucion: new FormControl('', [Validators.required]),
      areaTrabajo: new FormControl('', [Validators.required]),
      anoIngresoLaborar: new FormControl(''),
      horarioLaboral: new FormControl('', [Validators.required]),
      horarioDisponibleClases: new FormControl('', [Validators.required]),
      cargo: new FormControl('')
      
    });

    this.datosLaboralesForm.disable();


    let datosLaborales = JSON.parse(localStorage.getItem("DatosLaborales")) || {};

    this.trabajaForm.setValue(datosLaborales.trabaja = true);

    this.empleosArray = datosLaborales.empleo || [];

    this. setValue();

  }

  setValue() {

    let egresado = JSON.parse(localStorage.getItem("Egresado")) || [];
    let id 

    // Si hay datos de Egresado, usamos el primer objeto (suponiendo que hay uno solo)
    if (egresado.length > 0) {
      const datosEgresado = egresado[0];


      // Inicializar el formulario con los datos del Egresado
      this.datosPersonalesForm = new FormGroup({
        idDatosPersonales: new FormControl(datosEgresado.idDatosPersonales || 0),
        idFormaFinanciamiento: new FormControl(1),
        idMotivoPostulacion: new FormControl(1),
        idHorario: new FormControl(1),
  
        idCentro: new FormControl(this.idCentro, [Validators.required]), //Parametro a recibir
        idCarrera: new FormControl(this.idCarrera, [Validators.required]), //Parametro a recibir
        idTipoIdentificacion: new FormControl( 1 || '', [Validators.required]),
        noIdentificacion: new FormControl((datosEgresado.identidad || '').toString().trim(), [Validators.required]),
        noCuenta: new FormControl(datosEgresado.cuentaAlumno || ''),
        CorreoInstitucional: new FormControl(datosEgresado.correoInstitucional || ''),
        primerNombre: new FormControl(datosEgresado.primerNombre || '', [Validators.required]),
        segundoNombre: new FormControl(datosEgresado.segundoNombre || ''),
        primerApellido: new FormControl(datosEgresado.primerApellido || '', [Validators.required]),
        segundoApellido: new FormControl(datosEgresado.segundoApellido || ''),
        sexo: new FormControl(datosEgresado.idGenero || '', [Validators.required]),
        idNacionalidad: new FormControl(datosEgresado.idNacionalidad || '', [Validators.required]),
        fechaNacimiento: new FormControl(datosEgresado.fechaNacimiento || '', [Validators.required]),
        idEstadoCivil: new FormControl(datosEgresado.idEstadoCivil || '', [Validators.required]),
        lugarNaciemiento: new FormControl(datosEgresado.lugarNaciemiento || '', [Validators.required]),
        direccionResidencia: new FormControl(datosEgresado.direccion || '', [Validators.required]),
        correoElectronico: new FormControl(datosEgresado.correoPersonal || '',  [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
        ]),
        confirmarCorreo: new FormControl('', [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
        ]),
        celularContacto: new FormControl(datosEgresado.celular || '', [Validators.required]),
        telefonoCasaContacto: new FormControl(datosEgresado.telefonoCasaContacto || ''),
        telefonoCelular: new FormControl(datosEgresado.telefonoCelular || ''),
        telefonoOficinaContacto: new FormControl(datosEgresado.telefonoOficinaContacto || ''),
        telefonoAlternativo: new FormControl(datosEgresado.telefonoAlternativo || ''),
        idGrupoEtnico: new FormControl(datosEgresado.idGrupoEtnico || ''),
        idTipoDiscapacidad: new FormControl(datosEgresado.idTipoDiscapacidad || ''),
      }, { validators: this.validarCorreosIguales.bind(this) });
      // this.datosPersonalesForm.get(`sexo`).setValue(datosEgresado.idGenero);
      // this.datosPersonalesForm.get(`idTipoIdentificacion`).setValue(1);
      const sexo = String(datosEgresado.idGenero);
     
      this.datosPersonalesForm.get(`idTipoIdentificacion`).setValue('1');
      this.datosPersonalesForm.get(`sexo`).setValue(sexo);
      this.datosPersonalesForm.get(`idNacionalidad`).setValue('5');

    } 


  }
  
  confirmarDatosGenerales() {
    if (this.datosPersonalesForm.invalid) {
      this.datosPersonalesForm.markAllAsTouched();
      this.toast.mensajeWarning('Es necesario completar los campos marcados como requeridos', '');
      return;
    }
    localStorage.setItem("DatosGenerales", JSON.stringify(this.datosPersonalesForm.value))
    //this.myStepper.next();

  }

  guardarDatosAcademicos() {
    if (this.datosAcademicosForm.invalid) {
      this.toast.mensajeWarning('Es requerido completar los campos marcados como obligatorios', '');
      this.datosAcademicosForm.markAllAsTouched();
      return;
    }

    // Verificar si está en modo edición
    if (this.editingIndex !== null && this.editingIndex !== undefined) {
      // Actualizar el registro existente
      this.datosAcademicos[this.editingIndex] = this.datosAcademicosForm.value;
      this.editingIndex = null; // Salir del modo edición
    } else if (this.contadorEducacion < 3 ) {
      this.contadorEducacion++;  
      this.datosAcademicos.push(this.datosAcademicosForm.value);

      this.datosAcademicosForm = new FormGroup({
        idGradoAcademico: new FormControl('', [Validators.required]),
        nombreGradoAcademico: new FormControl(''),
        titulo: new FormControl('', [Validators.required]),
        institucion: new FormControl('', [Validators.required]),
        nombreInstitucion: new FormControl(''),
        anoGraducion: new FormControl(''),
        indiceGraduacion: new FormControl(''),
        idUniversidad: new FormControl(''),
        duracionEstudio: new FormControl(''),
        

    });
  }
  else{
    this.toast.mensajeWarning('Ha excedido el máximo Ingreso de datos solicitados. (Máximo 3)', '');
    this.datosAcademicosForm.markAllAsTouched();
      this.modal.closeAll();
    }
    this.datosAcademicosForm.reset();
    this.modal.closeAll();

  }
 
  guardarIdioma() {
    if (this.lenguajeForm.invalid) {
      this.toast.mensajeWarning('Es requerido completar los campos marcados como obligatorios' , '');
      this.lenguajeForm.markAllAsTouched();
      return;
    }

      if (this.editLenguajeIndex !== null && this.editLenguajeIndex !== undefined) {
        this.lenguaje[this.editLenguajeIndex] = this.lenguajeForm.value;
        this.editLenguajeIndex = null; 
      } else  if (this.contador < 3) {
      this.contador++;

      this.lenguaje.push(this.lenguajeForm.value);

      this.lenguajeForm = new FormGroup({
        idIdioma: new FormControl('', [Validators.required]),
        idioma: new FormControl(''),
        comprende: new FormControl('', [Validators.required]),
        nombreComprende: new FormControl(''),
        habla: new FormControl('', [Validators.required]),
        nombrehabla: new FormControl(''),
        lee: new FormControl('', [Validators.required]),
        nombreLee: new FormControl(''),
        escribe: new FormControl('', [Validators.required]),
        nombreEscribe: new FormControl(''),
      });
  }
  else{
  this.toast.mensajeWarning('Ha excedido el máximo Ingreso de datos solicitados. (Máximo 3)', '');
  this.lenguajeForm.markAllAsTouched();
    this.modal.closeAll();
  }
  this.lenguajeForm.reset();
  this.modal.closeAll();
  }

  guardarOtrosEstudios() {
    if (this.otrosEstudiosForm.invalid) {
      this.toast.mensajeWarning('Es requerido completar los campos marcados como obligatorios', '');
      this.otrosEstudiosForm.markAllAsTouched();
      return;
    }

    if (this.editOtroEstudioIndex !== null && this.editOtroEstudioIndex !== undefined) {
      this.diplomadoArray[this.editOtroEstudioIndex] = this.otrosEstudiosForm.value;
      this.editOtroEstudioIndex = null; 
    } else if (this.contadorOtros < 3 ) {
      this.contadorOtros++;

      this.diplomadoArray.push(this.otrosEstudiosForm.value);

      this.otrosEstudiosForm = new FormGroup({
        idTipoEstudio: new FormControl('', [Validators.required]),
        nombreTipoEstudio: new FormControl(''),
        titulo: new FormControl('', [Validators.required]),
        institucion: new FormControl('', [Validators.required]),
        anoObtencion: new FormControl('', [Validators.required]),
      })
  }
  else{
    this.toast.mensajeWarning('Ha excedido el máximo Ingreso de datos solicitados. (Máximo 3)', '');
    this.otrosEstudiosForm.markAllAsTouched();
      this.modal.closeAll();
    }
    this.otrosEstudiosForm.reset();
    this.modal.closeAll();

  }

  guardarEmpleo() {
    if (this.datosLaboralesForm.invalid) {
      this.toast.mensajeWarning('Es requerido completar los campos marcados como obligatorios', '');
      this.datosLaboralesForm.markAllAsTouched();
      return;
    }

      if (this.editExperienciaLaboralIndex !== null && this.editExperienciaLaboralIndex !== undefined) {
        this.empleosArray[this.editExperienciaLaboralIndex] = this.datosLaboralesForm.value;
        this.editExperienciaLaboralIndex = null; 
      } else  if (this.contadorTrab < 3) {
      this.contadorTrab++;
      this.empleosArray.push(this.datosLaboralesForm.value);

    this.datosLaboralesForm = new FormGroup({
      idTipoInstitucion: new FormControl('', [Validators.required]),
      nombreTipoInstitucion: new FormControl('', [Validators.required]),
      institucion: new FormControl('', [Validators.required]),
      areaTrabajo: new FormControl(''),
      anoIngresoLaborar: new FormControl(''),
      horarioLaboral: new FormControl('', [Validators.required]),
      horarioDisponibleClases: new FormControl('', [Validators.required]),
      cargo: new FormControl('')
    });
  }
  else{
    this.toast.mensajeWarning('Ha excedido el máximo Ingreso de datos solicitados. (Máximo 3)', '');
    this.lenguajeForm.markAllAsTouched();
      this.modal.closeAll();
    }
    this.datosLaboralesForm.reset();
    this.modal.closeAll();

  }

  confirmarDatosAcademicos() {
  
    let DatosAcademicos = {
      datosAcademicos: this.datosAcademicos,
      lenguaje: this.lenguaje,
      diplomadoArray: this.diplomadoArray,
    };
    localStorage.setItem("DatosAcademicos", JSON.stringify(DatosAcademicos));
    //this.myStepper.next();

  }

  confirmarDatosLaborales() {

    localStorage.setItem("DatosLaborales", JSON.stringify({trabaja: this.trabajaForm.value, empleo: this.empleosArray}))

    this.myStepper.next();
  }


  //------------------Modales---------------

  educacionSuperiorModal(template) {
    let dialog = this.modal.open(template, {
      width: "80%",
      panelClass: "app-full-bleed-dialog",
      disableClose: true
    });

    this.suscripciones.add(dialog.afterClosed().subscribe((result) => {

     }));
  }

  idiomaModal(template) {
    let dialog = this.modal.open(template, {
      width: "80%",
      panelClass: "app-full-bleed-dialog",
      disableClose: true

    });

    this.suscripciones.add(dialog.afterClosed().subscribe((result) => { }));
  }

  otrosEstudiosModal(template) {
    let dialog = this.modal.open(template, {
      width: "80%",
      panelClass: "app-full-bleed-dialog",
      disableClose: true

    });

    this.suscripciones.add(dialog.afterClosed().subscribe((result) => { }));
  }

  empleoModal(template) {
    let dialog = this.modal.open(template, {
      width: "80%",
      panelClass: "app-full-bleed-dialog",
      disableClose: true

    });

    this.suscripciones.add(dialog.afterClosed().subscribe((result) => { }));
  }

  salir(){
    this.datosAcademicosForm.reset();
    this.lenguajeForm.reset();
    this.otrosEstudiosForm.reset();
    this.datosLaboralesForm.reset();
    this.editingIndex = null
    this.editLenguajeIndex = null
    this.editOtroEstudioIndex = null
    this.editExperienciaLaboralIndex = null
  }

  guardarPostulacion() {
    if (this.datosPostulacion.invalid) {
      this.toast.mensajeWarning('Es necesario completar los campos marcados como requeridos', '');
      this.datosPostulacion.markAllAsTouched();
      return;
    }

    let params = this.datosPersonalesForm.value;
    params.postulacion = [this.datosPostulacion.value];

    this.myStepper.next();
    
  }

  
  guardarSolicitud() {

    let params = this.datosPersonalesForm.value;
    params.educacionSuperior = this.datosAcademicos;
    params.idiomas = this.lenguaje;
    params.otrosEstudios = this.diplomadoArray;
    params.trabajos = this.empleosArray;
    params.postulacion = [this.datosPostulacion.value];
    params.trabajaActualmente =this.trabajaForm.value;
    params.idModalidad= this.datosCarrera.idModalidad;
    params.idOrientacion = this.orientacionSeleccionada ?? null;


    // console.log(params)
    this.fichaAdmisionFacade.guardarSolicitud(params);
    this.fichaAdmisionFacade.responseAction$.pipe(take(1)).subscribe((result) => {
      if (result.hasError === false) {
        localStorage.removeItem('DatosAcademicos');
        localStorage.removeItem('DatosGenerales');
        localStorage.removeItem('DatosLaborales');

        this.solicitudEnviada = true;

        // El SP de creación de solicitud regresa el id en un segundo recordset: SELECT @idSolicitud AS solicitud;
        const idSolicitudCreada = result?.data?.Table1?.[0]?.solicitud;

        if (idSolicitudCreada) {
          this.idSolicitudCreada = idSolicitudCreada;

          this.suscripciones.add(
            this.fichaAdmisionFacade.generarRequisitosPostulacion(idSolicitudCreada).subscribe(() => {
              this.suscripciones.add(
                this.fichaAdmisionFacade.mostrarRequisitosPostulacion(idSolicitudCreada, '').subscribe((postulacion: any) => {
                  this.postulacionInfo = postulacion;
                  this.requisitosPostulacion = postulacion?.requisitos || [];
                  this.detallesPostulacion = postulacion?.detalles || [];
                  this.requisitosAgrupados = this.agruparRequisitosPostulacion(this.requisitosPostulacion, this.detallesPostulacion);

                  // Solo se muestra el paso si la carrera exige postulación, hay un proceso de
                  // admisión vigente para ella (idProcesoCarrera) y además tiene requisitos configurados.
                  const hayRequisitosQueMostrar = !!postulacion?.requierePostulacion
                    && !!postulacion?.idProcesoCarrera
                    && this.requisitosPostulacion.length > 0;

                  if (hayRequisitosQueMostrar) {
                    this.mostrarRequisitosPostulacion = true;
                  } else {
                    this.finalizarPostulacion();
                  }
                })
              );
            })
          );
        } else {
          this.finalizarPostulacion();
        }
      }

    });


  }

  finalizarPostulacion() {
    this.sweetAlertService.mensajeSimple('Solicitud enviada correctamente', 'Pronto nos pondremos en contacto para la gestión de su solicitud.', 'info');
    this.router.navigateByUrl('/inicio');
  }

  // Botón "Finalizar" del paso de subida de requisitos de postulación: a
  // diferencia de finalizarPostulacion() (que se usa justo al guardar la
  // solicitud, cuando la carrera NO exige requisitos de postulación), acá el
  // postulante ya vio y pudo subir sus documentos, así que en vez de mandarlo
  // directo a /inicio se le recuerda que tiene credenciales por correo para
  // volver a entrar y darle seguimiento a su postulación.
  continuarPostulacion(): void {
    Swal.fire({
      width: 400,
      html: `
        <style>
          .continuar-postulacion-swal.swal2-popup {
            border-radius: 18px;
            padding: 0 0 26px;
            overflow: hidden;
            font-family: 'DM Sans', sans-serif;
          }
          .continuar-postulacion-swal.swal2-popup::before {
            content: '';
            display: block;
            height: 4px;
            background: linear-gradient(90deg, #013775 0%, #ff9900 100%);
          }
          .continuar-postulacion-swal .swal2-html-container { margin: 20px 24px 0 !important; }
          .continuar-postulacion-swal .swal2-actions { margin-top: 18px !important; }
          .continuar-icon {
            width: 56px; height: 56px; margin: 0 auto 14px;
            border-radius: 50%; display: flex; align-items: center; justify-content: center;
            background: rgba(1,55,117,0.08);
          }
          .continuar-icon .material-icons { font-size: 28px; color: #013775; }
          .continuar-postulacion-title { font-size: 1.1rem; font-weight: 700; color: #013775; margin: 0 0 8px; }
          .continuar-postulacion-text { font-size: 13px; color: #55606e; line-height: 1.55; margin: 0; }
          .continuar-postulacion-btn-cancel {
            display: inline-flex; align-items: center; gap: 6px;
            font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 13px; color: #013775;
            background: transparent; border: 1.5px solid rgba(1,55,117,0.25);
            border-radius: 50px; padding: 9px 22px; cursor: pointer;
            transition: border-color .2s, background .2s;
          }
          .continuar-postulacion-btn-cancel:hover { background: rgba(1,55,117,0.06); border-color: #013775; }
          .continuar-postulacion-btn-confirm {
            display: inline-flex; align-items: center; gap: 6px;
            font-family: 'DM Sans', sans-serif; font-weight: 700; font-size: 13px; color: #01285a;
            background: linear-gradient(135deg, #ff9900 0%, #e67e00 100%);
            border: none; border-radius: 50px; padding: 9px 22px; cursor: pointer;
            box-shadow: 0 3px 10px rgba(255,153,0,0.35);
            transition: box-shadow .2s, transform .2s;
          }
          .continuar-postulacion-btn-confirm:hover { box-shadow: 0 6px 18px rgba(255,153,0,0.5); transform: translateY(-1px); }
        </style>
        <div class="continuar-icon"><span class="material-icons">mark_email_read</span></div>
        <h4 class="continuar-postulacion-title">¡Revise su correo!</h4>
        <p class="continuar-postulacion-text">
          Le enviamos un correo con sus credenciales de acceso. Con ellas puede volver a entrar
          cuando quiera para darle seguimiento a su postulación y subir o reemplazar sus documentos.
        </p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Iniciar sesión',
      cancelButtonText: 'Salir',
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: 'continuar-postulacion-swal',
        confirmButton: 'continuar-postulacion-btn-confirm',
        cancelButton: 'continuar-postulacion-btn-cancel',
      },
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.router.navigateByUrl('/postulante/login');
      } else {
        this.router.navigateByUrl('/inicio');
      }
    });
  }

  private refrescarRequisitosPostulacion(): void {
    if (!this.idSolicitudCreada) return;

    this.suscripciones.add(
      this.fichaAdmisionFacade.mostrarRequisitosPostulacion(this.idSolicitudCreada, '').subscribe((postulacion: any) => {
        this.postulacionInfo = postulacion;
        this.requisitosPostulacion = postulacion?.requisitos || [];
        this.detallesPostulacion = postulacion?.detalles || [];
        this.requisitosAgrupados = this.agruparRequisitosPostulacion(this.requisitosPostulacion, this.detallesPostulacion);
      })
    );
  }

  // Agrupa por TIPO de requisito (Congreso 1, Fotografía, etc.), no por
  // idPostulacionRequisito: Administracion.tblRequisitoCarreraPostulacion liga
  // cada entregable individual a UN idRequisitoPostulacionDetalle, así que un
  // mismo tipo con varios entregables genera varias cabeceras (tblPostulacionRequisito)
  // distintas — agrupar por esa columna partía "Congreso 1" en dos tablas iguales.
  //
  // Se agrupa UNA sola vez al cargar los datos (no en un getter/método dentro del
  // *ngFor: NgForOf compara por identidad y, si en cada ciclo de detección de
  // cambios se le da un arreglo/objetos nuevos, destruye y vuelve a crear el DOM
  // de las filas en cada ciclo, lo que puede tirar el clic de un botón justo entre
  // el mousedown y el click).
  //
  // El estado que se muestra a nivel de grupo es el más crítico entre sus
  // cabeceras (mismo criterio que Solicitudes.spPostulacionRequisitoDetalleDictaminar
  // usa para hacer burbujear el estado del padre): Rechazado > Subsanar >
  // Entregado > Pendiente > Aprobado.
  private agruparRequisitosPostulacion(cabeceras: any[], detalles: any[]): any[] {
    const prioridadEstado: { [estado: string]: number } = {
      Rechazado: 1, Subsanar: 2, Entregado: 3, Pendiente: 4, Aprobado: 5
    };

    const vistos = new Map<number, any>();
    for (const cabecera of cabeceras) {
      let grupo = vistos.get(cabecera.idTipoRequisitoPostulacion);
      if (!grupo) {
        grupo = {
          idTipoRequisitoPostulacion: cabecera.idTipoRequisitoPostulacion,
          nombreRequisito: cabecera.nombreRequisito,
          descripcionRequisito: cabecera.descripcionRequisito,
          obligatorio: false,
          estadoRequisito: cabecera.estadoRequisito,
          detalles: []
        };
        vistos.set(cabecera.idTipoRequisitoPostulacion, grupo);
      }

      grupo.obligatorio = grupo.obligatorio || !!cabecera.obligatorio;
      if ((prioridadEstado[cabecera.estadoRequisito] || 99) < (prioridadEstado[grupo.estadoRequisito] || 99)) {
        grupo.estadoRequisito = cabecera.estadoRequisito;
      }
      grupo.detalles.push(...detalles.filter(d => d.idPostulacionRequisito === cabecera.idPostulacionRequisito));
    }
    return Array.from(vistos.values());
  }

  trackByRequisito(_index: number, requisito: any): number {
    return requisito.idTipoRequisitoPostulacion;
  }

  trackByDetalle(_index: number, detalle: any): number {
    return detalle.idPostulacionRequisitoDetalle;
  }

  claseEstadoRequisito(estado: string): string {
    switch (estado) {
      case 'Aprobado': return 'badge badge-success';
      case 'Rechazado': return 'badge badge-danger';
      case 'Subsanar': return 'badge badge-warning';
      case 'Entregado': return 'badge badge-info';
      default: return 'badge badge-secondary';
    }
  }

  // posgrado/DSA/año/mes/dia/nombreDocumento — misma ruta que ya se usaba con
  // el S3 viejo, no se toca: el nuevo flujo solo cambia el MECANISMO de subida
  // (PUT directo a una URL pre-firmada, sin pasar por el microservicio
  // apiUtils), no la carpeta destino dentro del bucket.
  private getFolderPath(): string {
    const ahora = new Date();
    const año = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const dia = String(ahora.getDate()).padStart(2, '0');
    return `DSA/${año}/${mes}/${dia}`;
  }

  // El bucket físico es el mismo para ambos flujos (unah.repositorio-si.edu.hn),
  // pero el microservicio viejo (S3Service, vía apiUtils) espera el bucket con
  // el sufijo "/posgrado" que se usaba al subir con el flujo viejo; rutaDocumento
  // ahí queda como URL pública completa. Con el flujo nuevo rutaDocumento guarda
  // solo la key (sin URL) y el bucket real es sin ese sufijo.
  private readonly BUCKET_S3_VIEJO = 'unah.repositorio-si.edu.hn/posgrado';
  private readonly BUCKET_S3_NUEVO = 'unah.repositorio-si.edu.hn';
  private readonly PREFIJO_URL_S3 = 'https://s3.amazonaws.com/';

  // A partir de rutaDocumento (que puede venir en cualquiera de los dos
  // formatos) deduce la key y el bucket a usar para borrar el objeto en S3.
  private obtenerKeyYBucketParaBorrar(rutaDocumento: string): { key: string; bucket: string } {
    const prefijoViejo = `${this.PREFIJO_URL_S3}${this.BUCKET_S3_VIEJO}/`;
    if (rutaDocumento.startsWith(prefijoViejo)) {
      return { key: rutaDocumento.slice(prefijoViejo.length), bucket: this.BUCKET_S3_VIEJO };
    }
    return { key: rutaDocumento, bucket: this.BUCKET_S3_NUEVO };
  }

  // Borra el documento anterior en S3 antes de reemplazarlo o eliminarlo,
  // mismo criterio que el ejemplo de referencia (ejemploS3/nueva-solicitud
  // .component.ts -> editarImg/eliminarImagen). Es BEST-EFFORT a propósito: si
  // el borrado falla (archivo ya no existe, bucket viejo con formato distinto,
  // el microservicio apiUtils no responde, etc.) no se bloquea ni la subida del
  // documento nuevo ni el borrado del renglón en base de datos — en el peor
  // caso el archivo viejo queda huérfano en S3, igual que ya pasa hoy si este
  // borrado no se intentara.
  private async borrarDocumentoAnteriorDeS3(rutaDocumento: string | null): Promise<void> {
    if (!rutaDocumento) return;
    const { key, bucket } = this.obtenerKeyYBucketParaBorrar(rutaDocumento);
    try {
      await this.srvS3.deleteImagen({ object: key, bucket }, () => { });
    } catch {
      // Best-effort: se ignora cualquier error, no debe bloquear el flujo principal.
    }
  }

  // Sube el archivo directo a S3 con una URL pre-firmada (nuevo S3): permite
  // archivos más grandes que el flujo viejo porque el archivo nunca pasa por
  // el backend/microservicio apiUtils. rutaDocumento pasa a guardar la KEY de
  // S3 (no una URL completa); descargarDocumentoRequisito ya sabe generar una
  // URL firmada fresca a partir de esa key.
  private async subirDocumentoAlBackend(file: File, detalle: any): Promise<boolean> {
    try {
      await this.borrarDocumentoAnteriorDeS3(detalle.rutaDocumento);

      // "posgrado/" no viene de getFolderPath() (esa función no cambia): en el
      // flujo viejo ese prefijo iba escondido en BUCKET_S3_VIEJO, que el
      // microservicio apiUtils concatenaba con la ruta. El endpoint nuevo no
      // tiene ese truco, así que hay que agregarlo aquí para que el archivo
      // caiga en la misma carpeta real de siempre (posgrado/DSA/año/mes/dia).
      const presignado: any = await this.fichaAdmisionFacade.obtenerUrlPresignadaRequisito({
        fileName: file.name,
        contentType: file.type,
        folder: `posgrado/${this.getFolderPath()}`,
      }).toPromise();

      const presignedUrl = presignado?.data?.[0]?.url;
      const key = presignado?.data?.[0]?.key;
      if (!presignedUrl || !key) {
        this.toast.mensajeWarning('No se pudo iniciar la subida del archivo. Intente nuevamente.', 'Mensaje', {});
        return false;
      }

      const respuestaS3 = await fetch(presignedUrl, {
        method: 'PUT',
        body: file,
        headers: { 'Content-Type': file.type },
      });
      if (!respuestaS3.ok) {
        this.toast.mensajeWarning('Ocurrió un error al subir el archivo.', 'Mensaje', {});
        return false;
      }

      const confirmacion: any = await this.fichaAdmisionFacade.confirmarSubidaS3Requisito(key).toPromise();
      if (!confirmacion || confirmacion.hasError !== false) {
        this.toast.mensajeWarning('No se pudo confirmar la subida del archivo.', 'Mensaje', {});
        return false;
      }

      const resultado: any = await this.fichaAdmisionFacade.subirDocumentoRequisitoPostulacion({
        idPostulacionRequisitoDetalle: detalle.idPostulacionRequisitoDetalle,
        rutaDocumento: key,
      }).toPromise();

      if (!resultado || resultado.hasError !== false) {
        this.toast.mensajeWarning('No se pudo guardar el documento.', 'Mensaje', {});
        return false;
      }

      this.toast.mensajeSuccess('Documento subido correctamente', '');
      return true;
    } catch (error) {
      this.toast.mensajeWarning('Ocurrió un error al subir el archivo.', 'Mensaje', {});
      return false;
    }
  }

  // Abre el modal de documento: si el requisito ya tiene uno subido, pide una URL
  // firmada fresca y lo muestra en vista previa (permite reemplazarlo desde ahí mismo).
  abrirModalDocumentoRequisito(detalle: any): void {
    this.detalleSeleccionado = detalle;
    this.archivoSeleccionadoRequisito = null;
    this.previewUrlRequisito = null;
    this.safePreviewUrlRequisito = null;
    this.isImageRequisito = false;
    this.isPdfRequisito = false;
    this.cargandoPreviewRequisito = false;

    if (detalle.rutaDocumento) {
      this.cargandoPreviewRequisito = true;

      // Compatibilidad con documentos antiguos que guardaron una URL pública completa
      // en vez de la key de S3: no hay que pedir una URL firmada, ya es visualizable.
      const esUrlPublica = /^https?:\/\//i.test(detalle.rutaDocumento);
      const mostrarPreview = (url: string | null) => {
        this.cargandoPreviewRequisito = false;
        if (!url) return;

        if (/\.pdf$/i.test(detalle.rutaDocumento)) {
          this.isPdfRequisito = true;
          this.safePreviewUrlRequisito = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
          this.isImageRequisito = true;
          this.previewUrlRequisito = url;
        }
      };

      if (esUrlPublica) {
        mostrarPreview(detalle.rutaDocumento);
      } else {
        this.fichaAdmisionFacade.descargarDocumentoRequisito(detalle.rutaDocumento).subscribe(mostrarPreview);
      }
    }

    const dialog = this.modal.open(this.documentoRequisitoTemplate, {
      width: '820px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
    });
    this.suscripciones.add(dialog.afterClosed().subscribe(() => { }));
  }

  cerrarModalDocumentoRequisito(): void {
    this.modal.closeAll();
  }

  onArchivoModalSeleccionado(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const tiposPermitidos = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!tiposPermitidos.includes(file.type)) {
      this.toast.mensajeWarning('Solo se permiten archivos PDF, JPG o PNG.', 'Mensaje', {});
      input.value = '';
      return;
    }

    const maxSizeMB = 25;
    if (file.size / (1024 * 1024) > maxSizeMB) {
      this.toast.mensajeWarning(`El archivo no puede superar los ${maxSizeMB} MB.`, 'Mensaje', {});
      input.value = '';
      return;
    }

    this.archivoSeleccionadoRequisito = file;
    this.isImageRequisito = false;
    this.isPdfRequisito = false;
    this.previewUrlRequisito = null;
    this.safePreviewUrlRequisito = null;

    if (file.type.startsWith('image/')) {
      this.isImageRequisito = true;
      const reader = new FileReader();
      reader.onload = () => { this.previewUrlRequisito = reader.result as string; };
      reader.readAsDataURL(file);
    } else if (file.type === 'application/pdf') {
      this.isPdfRequisito = true;
      this.safePreviewUrlRequisito = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
    }
  }

  async guardarDocumentoRequisitoModal(): Promise<void> {
    const file = this.archivoSeleccionadoRequisito;
    const detalle = this.detalleSeleccionado;
    if (!file || !detalle) return;

    this.guardandoDocumentoRequisito = true;
    const exito = await this.subirDocumentoAlBackend(file, detalle);
    this.guardandoDocumentoRequisito = false;

    if (exito) {
      this.cerrarModalDocumentoRequisito();
      this.refrescarRequisitosPostulacion();
    }
  }

  // Borrado best-effort del objeto en S3 (ver borrarDocumentoAnteriorDeS3): si
  // falla, igual se limpia la referencia en base de datos, para no dejar al
  // postulante con un botón de eliminar que nunca funciona por un problema del
  // microservicio de borrado.
  eliminarDocumentoRequisito(detalle: any): void {
    if (!detalle?.rutaDocumento) return;

    Swal.fire({
      title: '¿Eliminar documento?',
      text: `Se eliminará el archivo entregado para "${detalle.nombreDetalle}".`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(async (res: any) => {
      if (!res.isConfirmed) return;

      await this.borrarDocumentoAnteriorDeS3(detalle.rutaDocumento);

      this.fichaAdmisionFacade.eliminarDocumentoRequisitoPostulacion({
        idPostulacionRequisitoDetalle: detalle.idPostulacionRequisitoDetalle,
      }).subscribe((result: any) => {
        if (result && result.hasError === false) {
          this.toast.mensajeSuccess('Documento eliminado', '');
          this.refrescarRequisitosPostulacion();
        }
      });
    });
  }

  eliminarEducacionSuperior(item){
    Swal.fire({
      title: 'Confirmación',
      html: ` <p> ¿Esta seguro quiere eliminar el titulo: <b>${item.titulo}</b>? </p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#003399',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        
        this.datosAcademicos =  this.datosAcademicos.filter(d => d.titulo != item.titulo);

      }
    });
    this.contadorEducacion = this.contadorEducacion-1;
  }

  editarEducacionSuperior(item, index) {
    // Cargar los datos seleccionados en el formulario
    this.datosAcademicosForm.patchValue({
      idGradoAcademico: item.idGradoAcademico,
      nombreGradoAcademico: item.nombreGradoAcademico,
      titulo: item.titulo,
      institucion: item.institucion,
      nombreInstitucion: item.nombreInstitucion,
      anoGraducion: item.anoGraducion,
      indiceGraduacion: item.indiceGraduacion,
      idUniversidad: item.idUniversidad,
      duracionEstudio: item.duracionEstudio,
    });
  // Establecer el índice de edición
  this.editingIndex = index;
    // Abrir el modal

    this.educacionSuperiorModal(this.educacionTemplate)
    
  }


  eliminarLenguaje(item: { idioma: any; },indiceI: number){
    Swal.fire({
      title: 'Confirmación',
      html: ` <p> ¿Esta seguro quiere eliminar el siguiente idioma: <b>${item.idioma}</b>? </p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#003399',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        
        //return  this.lenguaje.some(d => d.idIdioma != indiceI);
        this.lenguaje.splice(indiceI, 1);
      }
    });
    this.contador = this.contador-1;
  }

  editarLenguaje(item, index) {
    // Cargar los datos seleccionados en el formulario
    this.lenguajeForm.patchValue({

      idIdioma:  item.idIdioma,
      idioma:  item.idioma,
      comprende:  item.comprende,
      nombreComprende:  item.nombreComprende,
      habla:  item.habla,
      nombrehabla:  item.nombrehabla,
      lee:  item.lee,
      nombreLee:  item.nombreLee,
      escribe:  item.escribe,
      nombreEscribe:  item.nombreEscribe,
    });
  this.editLenguajeIndex = index;

    this.idiomaModal(this.idiomaTemplate)
    
  }

  eliminarEstudios(item, indiceE){
    Swal.fire({
      title: 'Confirmación',
      html: ` <p> ¿Esta seguro quiere eliminar el siguiente estudio: <b>${item.titulo}</b>? </p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#003399',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {       
        //this.diplomadoArray =  this.diplomadoArray.filter(d => d.nombreTipoEstudio != item.nombreTipoEstudio);
        this.diplomadoArray.splice(indiceE, 1);
      }
    });
    this.contadorOtros = this.contadorOtros-1;
   
  }

  editarEstudios(item, index) {
    // Cargar los datos seleccionados en el formulario
    this.otrosEstudiosForm.patchValue({

      idTipoEstudio:  item.idTipoEstudio,
      nombreTipoEstudio:  item.nombreTipoEstudio,
      titulo:  item.titulo,
      institucion:  item.institucion,
      anoObtencion:  item.anoObtencion,
     
    });
  this.editOtroEstudioIndex = index;

    this.otrosEstudiosModal(this.otrosEstudiosTemplate)
    
  }

  eliminarDatosLaborales(item,indiceT){
    // console.log(item)
    Swal.fire({
      title: 'Confirmación',
      html: ` <p> ¿Esta seguro quiere eliminar el siguiente estudio: <b>${item.institucion}${indiceT}</b>? </p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#003399',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        
        //this.empleosArray =  this.empleosArray.filter(d => d.institucion != item.institucion && d.areaTrabajo != item.areaTrabajo);
        this.empleosArray.splice(indiceT, 1);
      }
    });
    this.contadorTrab = this.contadorTrab-1;
  }

  editarDatosLaborales(item, index) {
    // Cargar los datos seleccionados en el formulario
    this.datosLaboralesForm.patchValue({

      idTipoInstitucion:  item.idTipoInstitucion,
      nombreTipoInstitucion:  item.nombreTipoInstitucion,
      institucion:  item.institucion,
      areaTrabajo:  item.areaTrabajo,
      anoIngresoLaborar:  item.anoIngresoLaborar,
      horarioLaboral:  item.horarioLaboral,
      horarioDisponibleClases:  item.horarioDisponibleClases,


      
    });
  this.editExperienciaLaboralIndex = index;

    this.otrosEstudiosModal(this.experienciaLaboralTemplate)
    
  }
  //VALIDAR CAMPO IDENTIDAD
  
  validarInputIdentidad(event: KeyboardEvent) {
    const tipoIdent = Number(this.datosPersonalesForm.get('idTipoIdentificacion')?.value);
    const inputChar = event.key;
  
    if (tipoIdent === 1) {
      // Solo números
      const pattern = /^[0-9]$/;
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  
    if (tipoIdent === 2) {
      // Letras, números y algunos símbolos (por ejemplo, guion o espacio)
      const pattern = /^[a-zA-Z0-9]$/;      
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }


  validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    // const regex = /[a-zA-Z0-9]|\./;
    const regex = /^[a-zA-ZñÑ0-9]+$/; 
    if (!regex.test(key)) {
      event.returnValue = false;
       if (event.preventDefault) {
        event.preventDefault();
       }
     }
     
    }
    //VALIDAR CAMPO Nombres
  validateFormatName(event) {
    let key1;
    if (event.type === 'paste') {
      key1 = event.clipboardData.getData('text/plain');
    } else {
      key1 = event.keyCode;
      key1 = String.fromCharCode(key1);
    }
    // const regex1 = /[a-zA-Z]|\./;
    const regex1 = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ.]+$/;
     if (!regex1.test(key1)) {
      event.returnValue = false;
       if (event.preventDefault) {
        event.preventDefault();
       }
     }
     
    }
  // validateNumber(event) {
  //   let key2;
  //   if (event.type === 'paste') {
  //     key2 = event.clipboardData.getData('text/plain');
  //   } else {
  //     key2 = event.keyCode;
  //     key2 = String.fromCharCode(key2);
  //   }
  //   const regex2 = /[0-9]|\./;
  //     if (!regex2.test(key2)) {
  //     event.returnValue = false;
  //       if (event.preventDefault) {
  //       event.preventDefault();
  //       }
  //     }
      
  //   }  
   // Evitar pegar (Ctrl+V o clic derecho → Pegar)
disablePaste(event: ClipboardEvent) {
  event.preventDefault();
}

  // Quita el readonly al enfocar, evitando que Chrome autocomplete el correo al cargar la página
  quitarReadonly(event: any): void {
    event.target.removeAttribute('readonly');
  }
  validateNumber(event) {
    
    let key;
    if (event.type === 'paste') {
      key = (event as unknown as ClipboardEvent).clipboardData?.getData('text/plain') || '';
    } else {
      key = event.key;
    }
  
    // Solo permitir números
    const regex = /^[0-9]*$/;
  
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
      
    }  

    validateCel(event: KeyboardEvent) {
        let key;
    if (event.type === 'paste') {
      key = (event as unknown as ClipboardEvent).clipboardData?.getData('text/plain') || '';
    } else {
      key = event.key;
    }

    // Obtener el valor actual del input y la selección
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const selectionStart = input.selectionStart || 0;
    const selectionEnd = input.selectionEnd || 0;

    // no permite espacio al inicio
  const isValidPlusSign = key === ' ' && selectionStart === 0 && !currentValue.includes(' ');

    // Permitir solo dígitos, espacios, guiones y el signo de más al inicio
    const regex = /^[0-9\s]*$/;
    const isValidKey = regex.test(key) || (key === '+' && selectionStart === 0);

    // Permitir la tecla si es válida y la longitud no excede 15 caracteres (por ejemplo)
    if (!isValidKey ||  isValidPlusSign ||(currentValue.length >= 17 && selectionStart === selectionEnd)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
    }

    validateCuenta(event) {
      let key;
      if (event.type === 'paste') {
        key = (event as ClipboardEvent).clipboardData?.getData('text/plain') || '';
      } else {
        key = event.key;
      }
    
      // Obtener el valor actual del input y la selección
      const input = event.target as HTMLInputElement;
      const currentValue = input.value;
      const selectionStart = input.selectionStart || 0;
      const selectionEnd = input.selectionEnd || 0;
    
      // Permitir solo números y asegurarse de que la longitud total no exceda 11
      const regex = /^[0-9]*$/;
      const isValidKey = regex.test(key) && (currentValue.length + key.length <= 11);
    
      // Permitir la tecla si es válida
      if (!isValidKey) {
        event.returnValue = false;
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      }  

      getErrorMessage(controlName: string): string {
        const control = this.datosPersonalesForm.get(controlName);
        if (control?.hasError('required')) {
          return 'Este campo es obligatorio.';
        }
        if (control?.hasError('email')) {
          return 'Debe ser un correo válido.';
        }
        return '';
      }

      preventTyping(event: KeyboardEvent): void {
        event.preventDefault(); // Bloquea cualquier entrada del teclado
      }
      goToDatosGenerales(stepper: MatStepper): void {
        // Cambia al paso de "Datos Generales" (índice 0)
        stepper.selectedIndex = 0;
      }


      // Método para manejar cambios en la primera pregunta
  onCuentaConPublicacionesChange(event: any): void {
    const value = event.value; // Obtener valor del radio seleccionado
    if (value === 'False') {
      this.isExperienciaPublicacionVisible = false; // Ocultar el campo
      this.datosPostulacion.get('experienciaPublicacion')?.disable();
      this.datosPostulacion.get('experienciaPublicacion')?.setValue(''); // Limpiar valor
    } else {
      this.isExperienciaPublicacionVisible = true; // Mostrar el campo
      this.datosPostulacion.get('experienciaPublicacion')?.enable();
    }
  }

  // Método para manejar cambios en la segunda pregunta
  onExperienciaPreviaInvestigacionChange(event: any): void {
    const value = event.value; // Obtener valor del radio seleccionado
    if (value === 'False') {
      this.isExperienciaInvestigacionDisabled = true; // Deshabilitar el campo
      this.datosPostulacion.get('experiencaInvestigacion')?.disable(); // Deshabilitar en el formulario
      this.datosPostulacion.get('experiencaInvestigacion')?.setValue(''); // Limpiar valor
    } else {
      this.isExperienciaInvestigacionDisabled = false; // Habilitar el campo
      this.datosPostulacion.get('experiencaInvestigacion')?.enable(); // Habilitar en el formulario
    }
  }

  get orientacionSeleccionadaNombre(): string | null {
    if (!this.orientacionSeleccionada) return null;
    const o = this.orientaciones.find(x => x.idOrientacion == this.orientacionSeleccionada);
    return o ? o.orientacion : null;
  }

// Dentro del componente
validarCorreosIguales(formGroup: FormGroup) {
  const correo = formGroup.get('correoElectronico');
  const confirmarCorreo = formGroup.get('confirmarCorreo');

  if (!correo || !confirmarCorreo) return null;

  const correoValue = correo.value?.trim().toLowerCase() || '';
  const confirmarCorreoValue = confirmarCorreo.value?.trim().toLowerCase() || '';

   if (correoValue && confirmarCorreoValue) {
    if (correoValue !== confirmarCorreoValue) {
      confirmarCorreo.setErrors({ correosNoCoinciden: true });
      return { correosNoCoinciden: true };
    } else {
       if (confirmarCorreo.hasError('correosNoCoinciden')) {
        confirmarCorreo.setErrors(null);
      }
    }
  }

  return null;
}
      
}


